import { getLocation } from 'connected-react-router';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { ThankYouDataParams, useThankYouData, useTypedSelector } from '../../../hooks';
import { OppFailed } from '../OppFailedPage';
import { FailedRedirect } from './components/FailedRedirect';
import { Loading } from './components/Loading';
import { Success } from './components/Success';
import { TrackingPageThankyouRedirect } from './components/TrackingPageThankyouRedirect';

type Props = RouteComponentProps<ThankYouDataParams>;

export const ThankYouPage: React.FC<Props> = props => {
  const { isLoading, error, trId, ...rest } = useThankYouData(props.match.params);
  const location = useTypedSelector(getLocation);
  const paymentStatus = new URLSearchParams(location.search).get('payment_status') as 'canceled' | 'expired' | null;

  if (isLoading) {
    return <Loading />;
  }
  // Opp has retry option for failed payments
  if (rest.type === 'opp' && (error || paymentStatus === 'expired')) {
    return <OppFailed trId={trId} />;
  }
  // In all other error cases we need a redirect
  if (paymentStatus === 'canceled' || paymentStatus === 'expired' || paymentStatus === 'open') {
    return <FailedRedirect id={trId} type={rest.type} />;
  }
  if ((rest.type === 'payment_link' || rest.type === 'upsell') && rest.customerId) {
    return <TrackingPageThankyouRedirect customerId={rest.customerId} />;
  }
  // else great success!
  return <Success trId={trId} {...rest} />;
};
